import { __assign } from 'tslib';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { Box } from '../../Box/index.js';
import { useTheme } from '../../hooks/useTheme.js';
import { useMainNavContext } from '../MainNavContext/index.js';

var NotifyDot = function (props) {
    var handleStyleProps = useTheme().handleStyleProps;
    var themeKey = useMainNavContext().themeKey;
    var forwardProps = handleStyleProps(props, {
        themeKey: "".concat(themeKey, "NotifyDot"),
    });
    return (jsx("svg", __assign({ viewBox: "0 0 100 100" }, forwardProps, { children: jsx("circle", { className: "check", cx: "16", cy: "16", r: "16", fill: "currentColor" }) })));
};
var MainNavItemBody = function (_a) {
    var decor = _a.decor, description = _a.description, Icon = _a.icon, label = _a.label, notify = _a.notify;
    return (jsxs(Fragment, { children: [Icon && (jsxs(Box, __assign({ "data-icon": true, sx: { gridColumnEnd: 1 } }, { children: [jsx(Icon, {}), notify && (jsx(NotifyDot, { "data-notify-dot-collapsed": notify === "onNavCollapsed" }))] }))), jsx(Box, __assign({ "data-label": true }, { children: label })), decor && (jsx(Box, __assign({ "data-decor": true, sx: { gridColumnStart: 2, lineHeight: 0 } }, { children: decor }))), description && jsx(Box, __assign({ "data-description": true }, { children: description }))] }));
};

export { MainNavItemBody };
//# sourceMappingURL=index.js.map
